import axios from "axios";
import { FETCH_TICKET_ALERT_SETTINGS, FETCH_TICKET_SETTINGS } from "../constants/tickets";

const TICKETS_API_URL = `${process.env.REACT_APP_API_URL}/tickets`;

const ticketAuth = (token) => ({
  headers: { "Content-Type": "application/json", Authorization: `Token ${token}` },
});

export const getTicketCreationRules = (formID) => async (dispatch, getState) => {
  const token = getState().auth.token;
  if (!token) return [];
  const response = await axios.get(`${TICKETS_API_URL}/creation-rules/`, {
    ...ticketAuth(token), params: formID ? { feedback_form: formID } : {},
  });
  return response.data.results || response.data;
};

export const createTicketCreationRule = (data) => async (dispatch, getState) => {
  const token = getState().auth.token;
  const response = await axios.post(`${TICKETS_API_URL}/creation-rules/`, data, ticketAuth(token));
  return response.data;
};

export const updateTicketCreationRule = (id, data) => async (dispatch, getState) => {
  const token = getState().auth.token;
  const response = await axios.patch(`${TICKETS_API_URL}/creation-rules/${id}/`, data, ticketAuth(token));
  return response.data;
};

export const deleteTicketCreationRule = (id) => async (dispatch, getState) => {
  const token = getState().auth.token;
  await axios.delete(`${TICKETS_API_URL}/creation-rules/${id}/`, ticketAuth(token));
};

export const fetchTicketAlertSettings =
  (params) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        let response = await axios.get(`${TICKETS_API_URL}/alert-settings/`, {
          headers,
          params,
        });
        if (response.status === 200) {
          dispatch({
            type: FETCH_TICKET_ALERT_SETTINGS,
            data: response.data,
          });
        }
      } catch (error) {
        throw error;
      }
    }
  };

export const createTicketAlertSettings =
  (data) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        let response = await axios.post(
          `${TICKETS_API_URL}/alert-settings/`,
          data,
          {
            headers,
          }
        );
        if (response.status === 201) {
          await dispatch(
            fetchTicketAlertSettings({ feedback_form: data["feedback_form"] })
          );
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  };

export const deleteTicketAlertSetting =
  (alertSettingID, formID) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (!token) return;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    };
    await axios.delete(
      `${TICKETS_API_URL}/alert-settings/${alertSettingID}/`,
      { headers, params: { feedback_form: formID } }
    );
    return dispatch(fetchTicketAlertSettings({ feedback_form: formID }));
  };

export const fetchTicketAlertSettingsChoices =
  (params) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        let response = await axios.get(`${TICKETS_API_URL}/get-choices`, {
          headers,
          params,
        });
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        throw error;
      }
    }
  };

export const createTicketSettings =
  (data) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        let response = await axios.post(`${TICKETS_API_URL}/settings/`, data, {
          headers,
        });
        if (response.status === 200 || response.status === 201) {
          return response.data;
        }
      } catch (error) {
        throw error;
      }
    }
  };

  export const updateTicketSettings =
  (ticketSettingsID, formID, data) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        const params = {
          feedback_form: formID,
        }
        let response = await axios.put(`${TICKETS_API_URL}/settings/${ticketSettingsID}/`, data, {
          params,
          headers,
        });
        if (response.status === 200 || response.status === 201) {
          return response.data;
        }
      } catch (error) {
        throw error;
      }
    }
  };
  export const getTicketSettings =
  (params) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        let response = await axios.get(`${TICKETS_API_URL}/settings/`, {
          params,
          headers,
        });
        if (response.status === 200) {
          dispatch({
            type: FETCH_TICKET_SETTINGS,
            data: response.data,
          });
          return response.data;
        }
      } catch (error) {
        throw error;
      }
    }
  };

export const fetchTicketResolutionReport =
  (params) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (!token) return [];
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    };
    try {
      const response = await axios.get(`${TICKETS_API_URL}/report/`, {
        headers,
        params,
      });
      if (response.status === 200) {
        return response.data;
      }
      return [];
    } catch (error) {
      throw error;
    }
  };
